import { OcapiError } from '../../../../types/ocapi-error';
import { getResponseErrorBody } from '../../../../utils/get-response-error-body';
export var SetShowtimeErrorCodeV1;
(function (SetShowtimeErrorCodeV1) {
    /**
     * Seats unavailable or already reserved.
     */
    SetShowtimeErrorCodeV1[SetShowtimeErrorCodeV1["SeatsUnavailable"] = 10000] = "SeatsUnavailable";
    /**
     * Discount is not available for logged in loyalty member.
     */
    SetShowtimeErrorCodeV1[SetShowtimeErrorCodeV1["InvalidLoyaltyRecognition"] = 10001] = "InvalidLoyaltyRecognition";
    /**
     * Discount is invalid for the ticket type.
     */
    SetShowtimeErrorCodeV1[SetShowtimeErrorCodeV1["InvalidDiscount"] = 10100] = "InvalidDiscount";
    /**
     * Discount is invalid due to the showtime being on a public holiday.
     */
    SetShowtimeErrorCodeV1[SetShowtimeErrorCodeV1["DiscountInvalidForPublicHoliday"] = 10101] = "DiscountInvalidForPublicHoliday";
    /**
     * Discount is invalid due to the discount being excluded for this film.
     */
    SetShowtimeErrorCodeV1[SetShowtimeErrorCodeV1["DiscountInvalidForFilm"] = 10102] = "DiscountInvalidForFilm";
    /**
     * Discount is invalid due to the discount being excluded for this film's distributor.
     */
    SetShowtimeErrorCodeV1[SetShowtimeErrorCodeV1["DiscountInvalidForDistributor"] = 10103] = "DiscountInvalidForDistributor";
    /**
     * Third party member scheme ticket limit exceeded for showtime.
     */
    SetShowtimeErrorCodeV1[SetShowtimeErrorCodeV1["ThirdPartySchemeLimitExceeded"] = 10107] = "ThirdPartySchemeLimitExceeded";
    /**
     * Voucher is restricted to being used once per order
     */
    SetShowtimeErrorCodeV1[SetShowtimeErrorCodeV1["VoucherRestrictedToSingleRedemption"] = 12007] = "VoucherRestrictedToSingleRedemption";
})(SetShowtimeErrorCodeV1 || (SetShowtimeErrorCodeV1 = {}));
export class SetShowtimeErrorV1 extends OcapiError {
    constructor(errorCode, discountAvailabilityErrors) {
        const message = `Failed to set showtime. API error code ${errorCode}: ${SetShowtimeErrorCodeV1[errorCode]}`;
        super(errorCode, message);
        this.discountAvailabilityErrors = discountAvailabilityErrors;
    }
}
export async function getSetShowtimeErrorV1(error) {
    const errorBody = (await getResponseErrorBody(error));
    const errorCode = errorBody === null || errorBody === void 0 ? void 0 : errorBody.errorCode;
    return errorCode && Object.values(SetShowtimeErrorCodeV1).includes(errorCode)
        ? new SetShowtimeErrorV1(errorCode, errorBody === null || errorBody === void 0 ? void 0 : errorBody.discountAvailabilityErrors)
        : error;
}
//# sourceMappingURL=set-showtime-error.js.map